import type { AuthConfig } from '../types/app-config';

export const DEFAULT_AUTH_TOKEN_STORAGE_KEY = 'runtime-shell:auth-token';

export function resolveTokenStorageKey(auth?: AuthConfig): string {
  const configuredKey = auth?.tokenStorageKey?.trim();
  return configuredKey || DEFAULT_AUTH_TOKEN_STORAGE_KEY;
}

export function getStoredAuthToken(auth?: AuthConfig): string | null {
  if (typeof window === 'undefined') return null;
  const token = window.localStorage.getItem(resolveTokenStorageKey(auth));
  return token?.trim() || null;
}

export function setStoredAuthToken(token: string, auth?: AuthConfig): void {
  if (typeof window === 'undefined') return;
  const normalized = token.trim();
  if (!normalized) return;
  window.localStorage.setItem(resolveTokenStorageKey(auth), normalized);
}

export function clearStoredAuthToken(auth?: AuthConfig): void {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(resolveTokenStorageKey(auth));
}
